import { Component, ViewChild, ElementRef, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { MessageService } from 'src/app/services/message/message.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'formly-field-file',
  templateUrl: './form-type-file.component.html',
  styleUrls: ['./form-type-file.component.css']
})

export class FormTypeFileComponent extends FieldType implements OnInit {
 @ViewChild('fileupload') fileuploadInput: ElementRef;
  @ViewChild('filename') filenameInput: ElementRef;
  constructor(public messageService: MessageService) {
    
    super();
  }

  public data = null;
  
  ngOnInit() {
    this.data = this.to;
  }

  openUpload() {
    this.fileuploadInput.nativeElement.click();
  }

  getEmptyText(): string {
    if (typeof this.data.emptyText === 'function') {
      return this.data.emptyText();
    }
    return this.data.emptyText;
  }

  onFileChange(event) {
    if (event.target.files[0]) {
      const errorMessage = this.getLatin1ValidationErrorMessage(event.target.files[0].name);
      if(errorMessage) {
          this.messageService.showError(errorMessage);
      } else {
        this.filenameInput.nativeElement.value = event.target.files[0].name;
      }
    } else {
      this.filenameInput.nativeElement.value = '';
    }
  }

// Die Datenbank unterstützt nur Latin-1-Zeichen https://git.x-plor.de/b-tix/b-ox.de/-/issues/4574#note_94883
getLatin1ValidationErrorMessage(str: string): string {
  const errors: string[] = [];
  for (let i = 0; i < str.length; i++) {
    const code = str.charCodeAt(i);
    if (code > 255) {
      const char = str[i];
      errors.push(`Ungültiges Zeichen (U+${code.toString(16).toUpperCase().padStart(4, '0')}) an Position ${i + 1}`);
    }
  }

  return errors.length > 0 ? "Ungültiger Dateiname " + str + ". Es werden nur ISO 8859-1 bzw. Latin-1 Zeichen unterstüzt. "  + errors.join(', ') : null;
}
}
